import { Skeleton } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import type { FC } from 'react';

import { TOP_AREA_BANNER_HEIGHT } from '../../constants';
import { Root } from '../../styles';
import { TOP_AREA_BANNER_BENEFIT_BANNER_SKELETON } from './constants';

export const TopAreaBannerSkeleton: FC = () => {
  const { getTestId } = useTestId();

  return (
    <Root data-testid={getTestId(TOP_AREA_BANNER_BENEFIT_BANNER_SKELETON)}>
      <Skeleton
        animation="pulse"
        height={TOP_AREA_BANNER_HEIGHT}
        variant="rectangular"
        width="100%"
      />
    </Root>
  );
};
